/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import AccountingDashboard from "./AccountingDashboard.jsx";
import AccountingSettingsHome from "./accountingsettings/AccountingSettingsHome";
import CustomerAccountingList from "./transactions/CustomerAccountingList";
import JournalEntryList from "./transactions/JournalEntryList";
import TransactionsList from "./transactions/TransactionsList.jsx";
import VendorAccountingList from "./transactions/VendorAccountingList";
import PendingChequesList from "./transactions/PendingChequesList.jsx";

export default function AccountingHome(props) {
  const { t } = useTranslation();
  const translate = t;
  const [menuHeader, setMenuHeader] = useState("DashBoard");
  const [isDashBoardEnabled, setIsDashBoardEnabled] = useState(true);
  const [isSettingsEnabled, setIsSettingsEnabled] = useState(false);
  const [isTransactionEnabled, setIstransactionEnabled] = useState(false);
  const [isVendorTransaction, setIsVendorTransaction] = useState(false);
  const [isCustomerTransaction, setIsCustomerTransaction] = useState(false);
  const [isJournalEntryListEnabled, setIsJournalEntryListEnabled] =
    useState(false);
  const [isInterAccountTransaction, setIsInterAccountTransaction] =
    useState(false);
  const [isPendingChequeList, setIsPendingChequeList] = useState(false);
  const [type, setType] = useState("");

  props.biRef.AccountingHome = {
    parentEvent: parentEvent,
  };

  function parentEvent(eventType) {
    if (eventType == "returnHome") {
      handleHomeClicked();
    }
  }

  const resetView = (resetValue) => {
    /*1-Dash Board,2-JournalEntry,3-Credit Home,4-Debit Home,5-Settings*/
    switch (resetValue) {
      case 1:
        setMenuHeader(translate("Dash Board"));
        setIsDashBoardEnabled(true);
        setIsSettingsEnabled(false);
        setIstransactionEnabled(false);
        setIsVendorTransaction(false);
        setIsCustomerTransaction(false);
        setIsJournalEntryListEnabled(false);
        setType(null);
        break;
      case 2:
        setMenuHeader(translate("Journal Records"));
        setIsDashBoardEnabled(false);
        setIsSettingsEnabled(false);
        setIsVendorTransaction(false);
        setIsCustomerTransaction(false);
        setIstransactionEnabled(false);
        setIsJournalEntryListEnabled(true);
        setType("Journal");
        break;
      case 3:
        setMenuHeader(translate("Receipt"));
        setIsDashBoardEnabled(false);
        setIsSettingsEnabled(false);
        setIsVendorTransaction(false);
        setIsCustomerTransaction(false);
        setIstransactionEnabled(true);
        setIsJournalEntryListEnabled(false);
        setType("Receipt");
        break;
      case 4:
        setMenuHeader(translate("Payment"));
        setIsDashBoardEnabled(false);
        setIsSettingsEnabled(false);
        setIsVendorTransaction(false);
        setIsCustomerTransaction(false);
        setIstransactionEnabled(true);
        setIsJournalEntryListEnabled(false);
        setType("Payment");
        break;
      case 5:
        setMenuHeader(translate("Settings"));
        setIsDashBoardEnabled(false);
        setIsVendorTransaction(false);
        setIsCustomerTransaction(false);
        setIsSettingsEnabled(true);
        setIstransactionEnabled(false);
        setIsJournalEntryListEnabled(false);
        setType(null);
        break;
      case 6:
        setMenuHeader("Vendor");
        setIsDashBoardEnabled(false);
        setIsVendorTransaction(true);
        setIsCustomerTransaction(false);
        setIsSettingsEnabled(false);
        setIstransactionEnabled(false);
        setIsJournalEntryListEnabled(false);
        setType(null);
        break;
      case 7:
        setMenuHeader("Customer");
        setIsDashBoardEnabled(false);
        setIsVendorTransaction(false);
        setIsCustomerTransaction(true);
        setIsSettingsEnabled(false);
        setIstransactionEnabled(false);
        setIsJournalEntryListEnabled(false);
        setType(null);
        break;
      case 8:
        setMenuHeader("Inter Account");
        setIsDashBoardEnabled(false);
        setIsVendorTransaction(false);
        setIsCustomerTransaction(false);
        setIsSettingsEnabled(false);
        setIstransactionEnabled(true);
        setIsJournalEntryListEnabled(false);
        setType("CONTRA");
        break;
      case 9:
        setMenuHeader("Pending Cheques List");
        setIsDashBoardEnabled(false);
        setIsVendorTransaction(false);
        setIsCustomerTransaction(false);
        setIsSettingsEnabled(false);
        setIstransactionEnabled(false);
        setIsJournalEntryListEnabled(false);
        setIsPendingChequeList(true);
        // setType(null);
        break;
    }
  };
  const handleHomeClicked = () => {
    setMenuHeader(translate("Dash Board"));
    setIsDashBoardEnabled(true);
    setIsSettingsEnabled(false);
    setIstransactionEnabled(false);
    setIsCustomerTransaction(false);
    setIsVendorTransaction(false);
    setIsJournalEntryListEnabled(false);
    setIsInterAccountTransaction(false);
    setIsPendingChequeList(false);
    setType(null);
  };

  return (
    <div>
      {isDashBoardEnabled && (
        <AccountingDashboard
          resetView={resetView}
          showMessage={props.showMessage}
          setAlert={props.setAlert}
          context={props.context}
        />
      )}
      {isTransactionEnabled && (
        <TransactionsList
          type={type}
          resetView={resetView}
          handleHomeClicked={handleHomeClicked}
          showMessage={props.showMessage}
          setAlert={props.setAlert}
          context={props.context}
          showProgress={props.showProgress}
          hideProgress={props.hideProgress}
        />
      )}
      {isSettingsEnabled && (
        <AccountingSettingsHome
          resetView={resetView}
          handleHomeClicked={handleHomeClicked}
          showMessage={props.showMessage}
          setAlert={props.setAlert}
          context={props.context}
        />
      )}
      {isVendorTransaction && (
        <VendorAccountingList
          type={type}
          resetView={resetView}
          handleHomeClicked={handleHomeClicked}
          showMessage={props.showMessage}
          setAlert={props.setAlert}
          context={props.context}
          showProgress={props.showProgress}
          hideProgress={props.hideProgress}
        />
      )}
      {isCustomerTransaction && (
        <CustomerAccountingList
          type={type}
          resetView={resetView}
          handleHomeClicked={handleHomeClicked}
          showMessage={props.showMessage}
          setAlert={props.setAlert}
          context={props.context}
          showProgress={props.showProgress}
          hideProgress={props.hideProgress}
        />
      )}
      {isJournalEntryListEnabled && (
        <JournalEntryList
          handleHomeClicked={handleHomeClicked}
          showMessage={props.showMessage}
          setAlert={props.setAlert}
          context={props.context}
        />
      )}
      {isPendingChequeList && (
        <PendingChequesList
          handleHomeClicked={handleHomeClicked}
          showMessage={props.showMessage}
          setAlert={props.setAlert}
          context={props.context}
        />
      )}
    </div>
  );
}
